export class BadRequestError extends Error {
    public constructor(message = 'BAD_REQUEST') {
        super(message);
    }
}
